module.exports = __webpack_public_path__ + "img/nengajo-code.8ef41b88.jpg";